export const baseUrl = "https://main.hifiservices.in/";
export const baseUrlMedia = "https://main.hifiservices.in/media/";
export const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
  }
};
